export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8035.e5d81003.jpg";